"use client";

import { ThemeToggle } from "@modernatc/ui/theme-toggle";
import type { ThemePreference } from "@modernatc/ui/theme";
import { setThemePreference } from "@/app/actions/theme";

/**
 * The shared ThemeToggle, wired to also persist the choice to the signed-in
 * user's profile (so it follows them across devices). The toggle itself
 * already applies the theme + writes the cookie/localStorage instantly; this
 * just mirrors it to the account in the background.
 */
export function AppThemeToggle({ className }: { className?: string }) {
  return (
    <ThemeToggle
      className={className}
      onChange={(pref: ThemePreference) => {
        void setThemePreference(pref);
      }}
    />
  );
}
